module.exports = __webpack_public_path__ + "static/media/hyundai_logo.2891c2a9.png";